export const SITE_NAME_MR  = 'चैत्राली फाउंडेशन';
export const SITE_NAME_EN  = 'Chaitralee Foundation';
export const SITE_URL      = 'https://www.chaitraleefoundationpune.com';
export const FOUNDED_YEAR  = 2024;
export const CHAITRALEE_BORN   = '5 March 2005';
export const CHAITRALEE_PASSED = '1 November 2024';

export const DEFAULT_LANGUAGE = 'mr';
export const DEFAULT_THEME    = 'light';

export const NAV_ROUTES = [
  { key: 'nav.home',               path: '/',                     end: true  },
  { key: 'nav.about',              path: '/about',                end: false },
  { key: 'nav.whoIsChaitralee',    path: '/who-is-chaitralee',   end: false },
  { key: 'nav.chaitraleeActivities', path: '/chaitralee-world',  end: false },
  { key: 'nav.ourActivities',      path: '/our-activities',       end: false },
  { key: 'nav.ourGoal',            path: '/our-goal',             end: false },
  { key: 'nav.ourTeam',            path: '/our-team',             end: false },
  { key: 'nav.youCan',             path: '/you-can',              end: false },
  { key: 'nav.contact',            path: '/contact',              end: false },
];
